export default __webpack_public_path__ + "static/courseFlyerBack-44b9e6e9b8a9fa9f27aefe70eeb7ab6c.jpg";